import type { ButtonProps } from '@hover/blueprint';
import { Button } from '@hover/blueprint';
import React from 'react';

const ExpandButton = ({ ...props }: ButtonProps) => (
  <Button
    backgroundColor="neutral.backgroundDark"
    fill="outline"
    paddingLeft="10px"
    paddingRight="10px"
    {...props}
  >
    ...
  </Button>
);

export { ExpandButton };
